function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { color } from "noood/util/ui/color";
import { Store } from "noood/util/local-storage/Store";
import { IAppContext } from 'noood/contexts/contexts';
import { _luminanceOf } from 'noood/util/ui/color/computeLuminance';
import { _contrast } from "noood/util/ui/color/contrastBetween";
export default function IAppContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(function () {
      var _Store$get;
      return (_Store$get = Store.get('user-theme')) !== null && _Store$get !== void 0 ? _Store$get : 'system';
    }),
    _useState2 = _slicedToArray(_useState, 2),
    userTheme = _useState2[0],
    setUserTheme = _useState2[1]; // dark light system
  var _useState3 = useState(function () {
      var _window$getComputedSt, _ref2;
      var accentFromStorage = localStorage.getItem("user-accent");
      var computedStyles = (_window$getComputedSt = window.getComputedStyle(document.querySelector("body"))) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.getPropertyValue('--accent');
      return (_ref2 = accentFromStorage !== null && accentFromStorage !== void 0 ? accentFromStorage : computedStyles) !== null && _ref2 !== void 0 ? _ref2 : '#5b92ff';
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    accentColor = _useState4[0],
    setAccentColor = _useState4[1];
  var _useState5 = useState(function () {
      var _Store$get2;
      var userThemeFromStore = (_Store$get2 = Store.get('user-theme')) !== null && _Store$get2 !== void 0 ? _Store$get2 : 'system';
      userThemeFromStore = userThemeFromStore === void 0 || userThemeFromStore === null ? "light" : "dark";
      return userThemeFromStore === 'system' ? window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light' : userThemeFromStore;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    lightOrDark = _useState6[0],
    setLightOrDark = _useState6[1]; // dark light

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    collapseSubMenu = _useState8[0],
    setCollapseSubMenu = _useState8[1];
  useEffect(function () {
    var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    var handleChange = function handleChange() {
      var themeFromStorage = localStorage.getItem("user-theme");
      if (themeFromStorage === void 0 || themeFromStorage === null || themeFromStorage === "system") {
        var _mediaQuery = window.matchMedia("(prefers-color-scheme: dark)").matches;
        setLightOrDark(_mediaQuery ? "dark" : "light");
      }
    };
    mediaQuery.addEventListener("change", handleChange);
    return function () {
      return mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  useEffect(function () {
    var _document$getElements;
    var body = (_document$getElements = document.getElementsByTagName('body')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
    // determine if system is dark or light
    if (userTheme === 'system') {
      var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)").matches;
      setLightOrDark(mediaQuery ? "dark" : "light");
    } else setLightOrDark(userTheme);
  }, [userTheme]);
  useEffect(function () {
    var _ref3, _document$getElements2, _computedStyles$getPr;
    var isDark = (_ref3 = lightOrDark === 'dark') !== null && _ref3 !== void 0 ? _ref3 : 'light';
    var currentAccent = _getAccent();
    var body = (_document$getElements2 = document.getElementsByTagName('body')) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2[0];
    var computedStyles = window.getComputedStyle(document.querySelector("body"));
    body.style.setProperty("--accent", currentAccent);
    body.style.setProperty("--accent-dark", color.adjustShade(currentAccent, 5));
    body.style.setProperty("--accent-darker", color.adjustShade(currentAccent, 10));
    body.style.setProperty("--accent-darkest", color.adjustShade(currentAccent, 15));
    body.style.setProperty("--accent-light", color.adjustShade(currentAccent, -5));
    body.style.setProperty("--accent-lighter", color.adjustShade(currentAccent, -10));
    body.style.setProperty("--accent-lightest", color.adjustShade(currentAccent, -15));
    body.style.setProperty("--shade-05", isDark ? '#FFFFFF0D' : '#0000000D');
    body.style.setProperty("--shade-10", isDark ? '#FFFFFF1A' : '#0000001A');
    body.style.setProperty("--shade-15", isDark ? '#FFFFFF26' : '#00000026');
    body.style.setProperty("--shade-20", isDark ? '#FFFFFF33' : '#00000033');
    body.style.setProperty("--shade-30", isDark ? '#FFFFFF4D' : '#0000004D');
    body.style.setProperty("--shade-40", isDark ? '#FFFFFF66' : '#00000066');
    body.style.setProperty("--shade-50", isDark ? '#FFFFFF80' : '#00000080');
    body.style.setProperty("--shade-60", isDark ? '#FFFFFF99' : '#00000099');
    body.style.setProperty("--shade-70", isDark ? '#FFFFFFB3' : '#000000B3');
    body.style.setProperty("--shade-80", isDark ? '#FFFFFFCC' : '#000000CC');
    body.style.setProperty("--shade-90", isDark ? '#FFFFFFE6' : '#000000E6');
    body.style.setProperty("--shade-100", isDark ? '#FFFFFF' : '#000000');
    var shade = isDark ? '#443e49' : '#e3e3e3';
    var shadeNegative = isDark ? '#f16969' : '#be1e1e';
    var shadePositive = isDark ? '#96c74c' : '#96c74c';
    var shadeWarning = isDark ? '#c48050' : '#ea9137';
    body.style.setProperty("--shade-required", isDark ? '#b1b17c' : '#f9f0b7');
    body.style.setProperty("--shade-error", isDark ? '#cd5353' : '#be1e1e');
    body.style.setProperty("--shade-positive", shadePositive);
    body.style.setProperty("--shade-warning", shadeWarning);
    body.style.setProperty("--shade-negative", shadeNegative);
    body.style.setProperty("--shade-negative-dark", color.adjustShade(shadeNegative, 5));
    body.style.setProperty("--shade-negative-darker", color.adjustShade(shadeNegative, 10));
    body.style.setProperty("--shade-negative-darkest", color.adjustShade(shadeNegative, 15));
    body.style.setProperty("--shade-required-border", isDark ? '#fcfaa2' : '#d2cdbb');
    body.style.setProperty("--shade-success-on-required", isDark ? '#227d17' : '#227d17');
    body.style.setProperty("--shade", shade);
    body.style.setProperty("--shade-dark", color.adjustShade(shade, 10));
    body.style.setProperty("--shade-darker", color.adjustShade(shade, 15));
    body.style.setProperty("--shade-darkest", color.adjustShade(shade, 20));
    body.style.setProperty("--shade-light", color.adjustShade(shade, -50));
    body.style.setProperty("--shade-lighter", color.adjustShade(shade, -60));
    body.style.setProperty("--shade-lightest", color.adjustShade(shade, -70));
    body.style.setProperty("--text-on-accent", _getTextColor(currentAccent));
    body.style.setProperty("--text-on-required", '#333');
    body.style.setProperty("--text-on-required-secondary", color.appendAlpha("#333333", 50));
    body.style.setProperty("--text-on-shade-negative", '#ffffff');
    body.style.setProperty("--text-error", isDark ? '#f58383' : '#d04848');
    body.style.setProperty("--text-success", '#71bb2a');
    body.style.setProperty("color", isDark ? '#eaeaea' : '#3b3b3b');
    body.style.setProperty("--text-color", isDark ? '#eaeaea' : '#3b3b3b');
    body.style.setProperty("--roundness", (_computedStyles$getPr = computedStyles.getPropertyValue('--roundness')) !== null && _computedStyles$getPr !== void 0 ? _computedStyles$getPr : "0");
    body.style.setProperty("--more-roundness", '15px');
    body.style.setProperty("background-color", isDark ? '#443e49' : '#fefefe');
  }, [accentColor, lightOrDark]);
  var _getTextColor = function _getTextColor(hex) {
    var bgLuminance = _luminanceOf(hex);
    var contrastWhite = _contrast(bgLuminance, _luminanceOf('#dedede'));
    var contrastDarkGray = _contrast(bgLuminance, _luminanceOf('#4b4b4b'));
    return contrastWhite > contrastDarkGray ? '#FFFFFF' : '#333333';
  };
  var _getAccent = function _getAccent() {
    var _window$getComputedSt2, _ref4;
    var accentFromStorage = localStorage.getItem("user-accent");
    var computedStyles = (_window$getComputedSt2 = window.getComputedStyle(document.querySelector("body"))) === null || _window$getComputedSt2 === void 0 ? void 0 : _window$getComputedSt2.getPropertyValue('--accent');
    return (_ref4 = accentFromStorage !== null && accentFromStorage !== void 0 ? accentFromStorage : computedStyles) !== null && _ref4 !== void 0 ? _ref4 : '#5b92ff';
  };
  var _deriveTheme = function _deriveTheme() {
    if (userTheme === void 0 || userTheme === "system") {
      var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)").matches;
      return mediaQuery ? "dark" : "light";
    } else return userTheme;
  };
  return /*#__PURE__*/React.createElement(IAppContext.Provider, {
    value: {
      userTheme: userTheme,
      setUserTheme: setUserTheme,
      accentColor: accentColor,
      setAccentColor: setAccentColor,
      lightOrDark: lightOrDark,
      setLightOrDark: setLightOrDark,
      collapseSubMenu: collapseSubMenu,
      setCollapseSubMenu: setCollapseSubMenu
    }
  }, children);
}

// @ts-ignore

export function useIAppContext() {
  var context = useContext(IAppContext);
  // Error handling if used outside provider
  if (context === undefined) {
    throw new Error('useSomeContext must be used within a SomeContextProvider');
  }
  return context;
}